import { ExternalLinkWarningFields } from 'models/external-links-warning-types';

export interface ExternalLinksWarningModalProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  warningFields?: ExternalLinkWarningFields;
}
